import React from 'react';
import './_pageContainer.scss';

const PageContainer = ({ children }) => (
  <div className="page-container-main">
    {children}
  </div>
);

export default PageContainer; 